import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './Dashboard';
import Categories from './Categories';
import Items from './Items';
import Suppliers from './Suppliers';
import Projects from './Projects';
import Quotes from './Quotes';
import Comparison from './Comparison';
import Tags from './Tags';
import InvoiceDelivery from './InvoiceDelivery';
import ReceiptManagement from './ReceiptManagement';
import InvoiceMatching from './InvoiceMatching';
import { useAuth } from '../../context/AuthContext';

export const API_PREFIX = '/api/procurement';

// All procurement sub-permission keys
const PROCUREMENT_SUB_KEYS = [
  'proc_categories', 'proc_items', 'proc_suppliers', 'proc_projects',
  'proc_quotes', 'proc_comparison', 'proc_tags', 'proc_invoices', 'proc_receipts',
  'proc_invoice_matching'
];

// Sub-permission guard for individual procurement routes
function SubPermissionRoute({ permission, children }) {
  const { user, isSuperAdmin, isCompanyAdmin } = useAuth();

  if (isSuperAdmin || isCompanyAdmin) return children;
  const perms = user?.permissions || [];
  if (perms.includes('all')) return children;

  // Legacy: if user has 'procurement' but no specific sub-perms, allow full access
  const hasAnySub = PROCUREMENT_SUB_KEYS.some(k => perms.includes(k));
  if (perms.includes('procurement') && !hasAnySub) return children;

  if (perms.includes(permission)) return children;

  // No access — bounce back to procurement dashboard
  return <Navigate to="/procurement" replace />;
}

function ProcurementApp() {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/categories" element={<SubPermissionRoute permission="proc_categories"><Categories /></SubPermissionRoute>} />
      <Route path="/items" element={<SubPermissionRoute permission="proc_items"><Items /></SubPermissionRoute>} />
      <Route path="/suppliers" element={<SubPermissionRoute permission="proc_suppliers"><Suppliers /></SubPermissionRoute>} />
      <Route path="/projects" element={<SubPermissionRoute permission="proc_projects"><Projects /></SubPermissionRoute>} />
      <Route path="/quotes" element={<SubPermissionRoute permission="proc_quotes"><Quotes /></SubPermissionRoute>} />
      <Route path="/comparison" element={<SubPermissionRoute permission="proc_comparison"><Comparison /></SubPermissionRoute>} />
      <Route path="/tags" element={<SubPermissionRoute permission="proc_tags"><Tags /></SubPermissionRoute>} />
      <Route path="/invoice-delivery" element={<SubPermissionRoute permission="proc_invoices"><InvoiceDelivery /></SubPermissionRoute>} />
      <Route path="/receipts" element={<SubPermissionRoute permission="proc_receipts"><ReceiptManagement /></SubPermissionRoute>} />
      <Route path="/invoice-matching" element={<SubPermissionRoute permission="proc_invoice_matching"><InvoiceMatching /></SubPermissionRoute>} />
    </Routes>
  );
}

export default ProcurementApp;
